import React, { useMemo } from "react";
import { View } from "react-native";
import { graphql, useFragment } from "react-relay";
import { FileIcon_File$key } from "./__generated__/FileIcon_File.graphql";
import { AHIcon, Box, CircleSize, useCircleSize, AHFileIcon, AHFileIconType } from "arkh";
import { getFileTypeColor } from "../SuggestionItem/getFileTypeColor";
import { FileIconBox_file$key } from "./__generated__/FileIconBox_file.graphql";

export function FileIconRelay(props: {
  file: FileIcon_File$key;
  hideOrg?: boolean;
  size?: number;
}) {
  const file = useFragment(
    graphql`
      fragment FileIcon_File on File {
        type
        isOrg
      }
    `,
    props.file
  );
  const size = props.size ?? 30;

  if (file.isOrg && !props.hideOrg) {
    return (
      <View
        style={{
          height: size,
          width: size,
          overflow: "hidden",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <AHIcon type="org" />
      </View>
    );
  }

  return <AHFileIcon filetype={file.type as AHFileIconType} size={size} />;
}

export type FileIconType = AHFileIconType;

export const FileIcon = AHFileIcon;

export function FileIconBox(props: {
  file: FileIconBox_file$key;
  resolveOrgToFileType?: boolean;
  size?: CircleSize;
}) {
  const file = useFragment(
    graphql`
      fragment FileIconBox_file on File {
        type
        isOrg
        ...FileIcon_File
      }
    `,
    props.file
  );

  const color = useMemo(
    () =>
      getFileTypeColor(
        !props.resolveOrgToFileType && file.isOrg ? "org" : file.type
      ),
    [file.isOrg, file.type, props.resolveOrgToFileType]
  );

  const size = useCircleSize(props.size ?? "smallMedium");

  return (
    <Box
      style={{
        backgroundColor: color,
        height: size,
        width: size,
      }}
      cornerRadius="medium"
    >
      <Box
        style={{
          flex: 1,
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "rgba(255,255,255,0.9)",
        }}
      >
        <FileIconRelay
          hideOrg={props.resolveOrgToFileType}
          file={file}
          size={size * 0.65}
        />
      </Box>
    </Box>
  );
}
